// extracted by mini-css-extract-plugin
module.exports = {"space":"AnimatedPhrase_space__o24HV","word":"AnimatedPhrase_word__iOiAz","container":"AnimatedPhrase_container__ZTM41"};